/* =========================================================
   Proyector Navideño AR — assets/proyector-ar.js  (v2)

   FIX EasySell : la app inyecta su propio botón
   <div id="es-popup-button" class="es-popup-button es-popup-button-product
        cart-shaker es-animation-pulse es-animation-active">
   dentro de la zona de compra.

   Reglas:
   1) NUNCA se engancha el botón de EasySell (si no, su propio clic
      abre el popup y nuestro handler lo vuelve a clickear → se cierra).
   2) Ese botón ES el disparador: cualquier otro CTA de la página
      lo clickea a él.
   3) Si EasySell no intercepta el submit, el formulario se manda a
      un iframe oculto para no acabar en /cart.

   Depuración: abrí la página con ?pxdebug=1 y usá pxDebug() / pxTry(n).
   ========================================================= */
(function () {
  'use strict';

  var DEBUG = /[?&]pxdebug=1/.test(window.location.search);
  function log() {
    if (!DEBUG) return;
    try { console.log.apply(console, ['[px]'].concat([].slice.call(arguments))); } catch (e) {}
  }

  /* =======================================================
     0. UTILIDADES
     ======================================================= */

  /* offsetParent devuelve null en position:fixed → inservible para popups */
  function visible(el) {
    if (!el || !el.getBoundingClientRect) return false;
    var r = el.getBoundingClientRect();
    if (r.width < 2 || r.height < 2) return false;
    var cs = window.getComputedStyle(el);
    if (!cs) return false;
    return cs.display !== 'none' && cs.visibility !== 'hidden' && cs.opacity !== '0';
  }

  /* --- Selectores REALES de EasySell (prefijo es-, no easysell-) --- */
  var ES_BUTTON =
    '#es-popup-button, .es-popup-button, .es-popup-button-product, ' +
    '[id^="es-popup-button"], [class*="es-popup-button"]';

  var OTHER_TRIGGERS = [
    '.easysell-cod-form-btn', '.easysell-buy-button', '#easysell-button',
    '[class*="easysell"][class*="button"]', '[id*="easysell"][id*="button"]',
    '[data-easysell-trigger]', '.esf-trigger', '[class*="esf-"][class*="button"]',
    '.releasit-cod-form-button', '[class*="cod-form"] button', '[class*="cod-button"]'
  ];

  var ES_POPUP =
    '#es-popup, .es-popup, [class*="es-popup-wrapper"], [class*="es-popup-container"], ' +
    '[class*="es-form"], [class*="es-modal"]';

  var PHONE_INPUT =
    'input[type="tel"], input[name*="phone" i], input[id*="phone" i], ' +
    'input[name*="telefono" i], input[placeholder*="elular" i], input[placeholder*="eléfono" i]';

  /* ¿Este nodo es el botón de EasySell, o está dentro de él / del popup? */
  function isEasySellNode(el) {
    if (!el || !el.closest) return false;
    try {
      return !!el.closest(ES_BUTTON) || !!el.closest(ES_POPUP) || !!el.closest(OTHER_TRIGGERS.join(','));
    } catch (e) { return false; }
  }

  /* Huella de lo que hay abierto en pantalla: sirve para saber si el
     popup se abrió de verdad y dejar de intentar. */
  function openSignature() {
    var n = 0, i, nodes;

    nodes = document.querySelectorAll(ES_POPUP + ', dialog[open], [class*="modal"], [class*="popup"], [class*="drawer"]');
    for (i = 0; i < nodes.length; i++) if (visible(nodes[i])) n++;

    /* El formulario COD es casi siempre lo único con campo de teléfono */
    nodes = document.querySelectorAll(PHONE_INPUT);
    for (i = 0; i < nodes.length; i++) if (visible(nodes[i])) n += 2;

    /* Scroll del body bloqueado = modal abierto */
    var bs = window.getComputedStyle(document.body);
    if (bs && (bs.overflow === 'hidden' || bs.position === 'fixed')) n += 2;

    return n;
  }

  /* =======================================================
     1. CONTADOR
     ======================================================= */
  function initCountdown(root) {
    var box = root.querySelector('[data-px-count]');
    if (!box) return;

    var mins = parseInt(root.dataset.countdown, 10) || 120;
    var DUR = mins * 60 * 1000;
    var KEY = 'px_deadline_' + (root.id || 'default');
    var end = parseInt(localStorage.getItem(KEY) || '0', 10);
    if (!end || end < Date.now()) {
      end = Date.now() + DUR;
      try { localStorage.setItem(KEY, end); } catch (e) {}
    }

    var hh = box.querySelector('[data-px-hh]');
    var mm = box.querySelector('[data-px-mm]');
    var ss = box.querySelector('[data-px-ss]');
    function pad(n) { return n < 10 ? '0' + n : '' + n; }

    function tick() {
      var left = end - Date.now();
      if (left <= 0) {
        end = Date.now() + DUR;
        try { localStorage.setItem(KEY, end); } catch (e) {}
        left = DUR;
      }
      var t = Math.floor(left / 1000);
      if (hh) hh.textContent = pad(Math.floor(t / 3600));
      if (mm) mm.textContent = pad(Math.floor((t % 3600) / 60));
      if (ss) ss.textContent = pad(t % 60);
    }
    tick();
    setInterval(tick, 1000);
  }

  /* =======================================================
     2. BARRA ROTATIVA
     ======================================================= */
  function initAnnounce(root) {
    var items = root.querySelectorAll('[data-px-announce] .px-announce__item');
    if (items.length < 2) return;
    var i = 0;
    setInterval(function () {
      items[i].classList.remove('is-on');
      i = (i + 1) % items.length;
      items[i].classList.add('is-on');
    }, 3200);
  }

  /* =======================================================
     3. GALERÍA
     ======================================================= */
  function initGallery(root) {
    var gallery = root.querySelector('[data-px-gallery]');
    if (!gallery) return;
    var slides = [].slice.call(gallery.querySelectorAll('[data-px-slide]'));
    var thumbs = [].slice.call(gallery.querySelectorAll('[data-px-thumb]'));
    var track = gallery.querySelector('[data-px-thumbs]');
    var prev = gallery.querySelector('[data-px-prev]');
    var next = gallery.querySelector('[data-px-next]');
    var current = 0;

    if (slides.length < 2) {
      if (prev) prev.style.display = 'none';
      if (next) next.style.display = 'none';
      return;
    }

    function go(i) {
      current = (i + slides.length) % slides.length;
      slides.forEach(function (s, idx) {
        var on = idx === current;
        s.classList.toggle('is-active', on);
        var vid = s.querySelector('video');
        if (vid && !on) { try { vid.pause(); } catch (e) {} }
      });
      thumbs.forEach(function (t, idx) { t.classList.toggle('is-active', idx === current); });
      var active = thumbs[current];
      if (active && track) {
        track.scrollTo({
          left: active.offsetLeft - track.clientWidth / 2 + active.clientWidth / 2,
          behavior: 'smooth'
        });
      }
    }

    thumbs.forEach(function (t) {
      t.addEventListener('click', function () { go(parseInt(t.getAttribute('data-px-thumb'), 10)); });
    });
    if (prev) prev.addEventListener('click', function () { go(current - 1); });
    if (next) next.addEventListener('click', function () { go(current + 1); });

    var viewport = gallery.querySelector('.px-gallery__viewport');
    var x0 = 0, y0 = 0;
    if (viewport) {
      viewport.addEventListener('touchstart', function (e) {
        x0 = e.touches[0].clientX; y0 = e.touches[0].clientY;
      }, { passive: true });
      viewport.addEventListener('touchend', function (e) {
        var dx = e.changedTouches[0].clientX - x0;
        var dy = e.changedTouches[0].clientY - y0;
        if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) go(dx < 0 ? current + 1 : current - 1);
      }, { passive: true });
    }
  }

  /* =======================================================
     4. PACKS
     ======================================================= */
  function initPacks(root) {
    var inputs = [].slice.call(root.querySelectorAll('[data-px-pack-input]'));
    if (!inputs.length) return;
    var mode = root.dataset.packMode || 'variant';
    var idInput = root.querySelector('[data-px-id]');
    var qtyInput = root.querySelector('[data-px-qty]');

    function apply(input) {
      [].forEach.call(root.querySelectorAll('[data-px-pack]'), function (l) { l.classList.remove('is-active'); });
      var label = input.closest('[data-px-pack]');
      if (label) label.classList.add('is-active');

      if (mode === 'variant' && idInput && input.value) idInput.value = input.value;
      if (mode === 'quantity' && qtyInput && input.dataset.qty) qtyInput.value = input.dataset.qty;

      if (input.dataset.price) {
        [].forEach.call(root.querySelectorAll('[data-px-price], [data-px-sticky-price]'), function (el) {
          el.textContent = input.dataset.price;
        });
      }
      [].forEach.call(root.querySelectorAll('[data-px-compare], [data-px-sticky-compare]'), function (el) {
        el.textContent = input.dataset.compare || '';
        if (el.hasAttribute('data-px-compare')) el.hidden = !input.dataset.compare;
      });
    }

    inputs.forEach(function (input) {
      input.addEventListener('change', function () { apply(input); });
    });

    var checked = root.querySelector('[data-px-pack-input]:checked') || inputs[0];
    checked.checked = true;
    apply(checked);
  }

  /* =======================================================
     5. EASYSELL — TODOS LOS BOTONES ABREN EL POPUP
     ======================================================= */
  function initCTAs(root) {
    var buy = root.querySelector('[data-px-buy]');
    var form = root.querySelector('[data-px-form]');
    var ctaMode = root.dataset.ctaMode || 'native';
    var mode = root.dataset.secondaryAction || 'auto';
    var customSel = (root.dataset.codSelector || '').trim();
    var opening = false;
    var restoreT = null;

    var CTA_TEXT = /(pedir|comprar|quiero|lo\s*quiero|obten[eé]|aprovech[aá]|pago\s*(al\s*recibir|contra\s*entrega)|descuento|recibir)/i;

    /* ---- Iframe "papelera" -------------------------------------
       Si EasySell NO intercepta el submit, el formulario se manda
       ahí dentro y la página no se va a /cart. Si lo intercepta
       (caso normal), no se envía nada. */
    var sinkName = 'px-sink-' + String(root.id || 'x').replace(/[^\w-]/g, '');
    var sink = null;
    function armSink() {
      if (!form) return;
      if (!sink || !document.contains(sink)) {
        sink = document.createElement('iframe');
        sink.name = sinkName;
        sink.setAttribute('aria-hidden', 'true');
        sink.setAttribute('tabindex', '-1');
        sink.style.cssText = 'position:absolute!important;left:-9999px;top:0;width:1px;height:1px;border:0;opacity:0;pointer-events:none';
        document.body.appendChild(sink);
      }
      var prev = form.getAttribute('target');
      form.setAttribute('target', sinkName);
      clearTimeout(restoreT);
      restoreT = setTimeout(function () {
        if (prev === null) form.removeAttribute('target');
        else form.setAttribute('target', prev);
      }, 2500);
    }

    /* Modo checkout directo (opcional) */
    if (ctaMode === 'checkout' && form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var id = form.querySelector('[data-px-id]').value;
        var qty = Number(form.querySelector('[data-px-qty]').value) || 1;
        var base = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
        fetch(base + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [{ id: Number(id), quantity: qty }] })
        }).then(function (res) {
          if (!res.ok) throw new Error('add');
          window.location.href = base + 'checkout';
        }).catch(function () {});
      });
    }

    /* Clic "humano": algunas apps escuchan pointerdown, no click */
    function fireClick(el) {
      ['pointerdown', 'mousedown', 'mouseup'].forEach(function (type) {
        var Ctor = (type === 'pointerdown' && window.PointerEvent) ? PointerEvent : MouseEvent;
        try { el.dispatchEvent(new Ctor(type, { bubbles: true, cancelable: true, view: window })); } catch (e) {}
      });
      try { el.click(); }
      catch (e) {
        try { el.dispatchEvent(new MouseEvent('click', { bubbles: true, cancelable: true, view: window })); } catch (e2) {}
      }
    }

    /* El botón de EasySell, buscado EN VIVO: la app lo clona y lo
       reemplaza, una referencia guardada al cargar queda obsoleta. */
    function liveEsButton() {
      var scopes = [buy || root, root, document];
      for (var s = 0; s < scopes.length; s++) {
        var nodes;
        try { nodes = scopes[s].querySelectorAll(ES_BUTTON); } catch (e) { continue; }
        for (var i = 0; i < nodes.length; i++) {
          if (nodes[i].closest(ES_POPUP)) continue;   /* el de dentro del popup no */
          if (visible(nodes[i])) return nodes[i];
        }
      }
      return null;
    }

    function nativeBtn() { return root.querySelector('[data-px-main-btn]'); }

    /* ---- Estrategias, en orden de fiabilidad ---- */

    function stratCustom() {
      if (!customSel) return false;
      var c = document.querySelector(customSel);
      if (!c || !visible(c)) return false;
      fireClick(c);
      return true;
    }

    function stratEsButton() {
      var es = liveEsButton();
      if (!es) return false;
      fireClick(es);
      return true;
    }

    function stratNativeClick() {
      var btn = nativeBtn();
      if (!btn) return false;
      armSink();
      fireClick(btn);
      return true;
    }

    function stratSubmit() {
      if (!form) return false;
      armSink();
      var btn = nativeBtn();
      try {
        if (form.requestSubmit) form.requestSubmit(btn && form.contains(btn) ? btn : undefined);
        else form.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }));
        return true;
      } catch (e) {
        try { form.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true })); return true; }
        catch (e2) { return false; }
      }
    }

    function stratGlobals() {
      var names = ['EasySell', 'easySell', 'easysell', 'esPopup', 'ESF', 'esf', 'Releasit', 'CODForm'];
      var fns = ['openPopup', 'showPopup', 'openForm', 'showForm', 'open', 'show', 'trigger'];
      for (var i = 0; i < names.length; i++) {
        var o = window[names[i]];
        if (!o || (typeof o !== 'object' && typeof o !== 'function')) continue;
        for (var j = 0; j < fns.length; j++) {
          if (typeof o[fns[j]] === 'function') {
            try { o[fns[j]](); log('API global:', names[i] + '.' + fns[j]); return true; } catch (e) {}
          }
        }
      }
      return false;
    }

    function stratOtherTriggers() {
      for (var i = 0; i < OTHER_TRIGGERS.length; i++) {
        var nodes;
        try { nodes = document.querySelectorAll(OTHER_TRIGGERS[i]); } catch (e) { continue; }
        for (var j = 0; j < nodes.length; j++) {
          if (nodes[j].closest(ES_POPUP)) continue;
          if (visible(nodes[j])) { fireClick(nodes[j]); return true; }
        }
      }
      return false;
    }

    var STRATS = [
      ['selector personalizado', stratCustom],
      ['botón de EasySell (es-popup-button)', stratEsButton],
      ['clic en el botón nativo', stratNativeClick],
      ['submit del formulario', stratSubmit],
      ['API global', stratGlobals],
      ['otros disparadores COD', stratOtherTriggers]
    ];

    function scrollToBuy() {
      if (!buy) return;
      buy.scrollIntoView({ behavior: 'smooth', block: 'center' });
      var btn = liveEsButton() || nativeBtn();
      if (btn) {
        btn.classList.remove('is-pulse');
        setTimeout(function () { btn.classList.add('is-pulse'); }, 400);
      }
    }

    function focusForm(el) {
      el.scrollIntoView({ behavior: 'smooth', block: 'center' });
      setTimeout(function () {
        var f = el.querySelector('input:not([type="hidden"]):not([disabled]), select, textarea');
        if (f) { try { f.focus({ preventScroll: true }); } catch (e) { f.focus(); } }
      }, 550);
    }

    /* Formulario incrustado en la página (bloque de app) */
    var inlineWrap = root.querySelector('[data-px-cod]');
    function hasInline() {
      return !!(inlineWrap && inlineWrap.querySelector('input, select, textarea, iframe'));
    }

    function fallback() {
      log('ninguna estrategia funcionó → fallback');
      var nodes = document.querySelectorAll(PHONE_INPUT);
      for (var i = 0; i < nodes.length; i++) {
        if (visible(nodes[i])) {
          var f = nodes[i].closest('form, [class*="form"]') || nodes[i];
          focusForm(f);
          return;
        }
      }
      scrollToBuy();
    }

    function openForm() {
      if (mode === 'scroll') { scrollToBuy(); return; }

      /* Si el formulario está incrustado en la página, no hay popup que abrir */
      if (hasInline()) { focusForm(inlineWrap); return; }
      if (mode === 'inline') { scrollToBuy(); return; }

      if (opening) return;
      opening = true;

      var before = openSignature();
      var i = 0;
      log('huella inicial:', before);

      function step() {
        if (openSignature() > before) { log('popup abierto ✔'); opening = false; return; }
        if (i >= STRATS.length) { opening = false; fallback(); return; }
        var s = STRATS[i++];
        var fired = false;
        try { fired = s[1](); } catch (e) { log('error en', s[0], e); }
        log(fired ? 'intento: ' + s[0] : 'saltada: ' + s[0]);
        setTimeout(step, fired ? 650 : 0);
      }

      /* Pausa: si EasySell ya está enganchado al botón pulsado,
         el popup se abre solo y no tocamos nada. */
      setTimeout(step, 150);
    }

    /* ---- Enganche de los botones ------------------------------
       LA REGLA CLAVE: nunca enganchar el botón de EasySell ni nada
       que esté dentro del popup. Si lo hacemos, su propio clic abre
       el popup y nuestro handler lo vuelve a clickear → se cierra.
       (Ese era exactamente el bug: data-easy-px-bound="1" sobre
       #es-popup-button.) */
    function bind(el) {
      if (el.dataset.pxBound) return;
      if (isEasySellNode(el)) { log('excluido (EasySell):', el.id || el.className); return; }
      if (el.hasAttribute('data-px-main-btn')) return;     /* lo maneja la app */
      if (el.closest('[data-px-cod]')) return;             /* formulario incrustado */
      if (el.closest('[data-px-gallery], [data-px-faq], [data-px-carousel]')) return;
      if (el.hasAttribute('data-px-thumb') || el.hasAttribute('data-px-prev') ||
          el.hasAttribute('data-px-next') || el.hasAttribute('data-px-like')) return;

      el.dataset.pxBound = '1';
      el.style.cursor = 'pointer';
      el.addEventListener('click', function (e) {
        if (el.tagName === 'A') e.preventDefault();
        openForm();
      });
      /* sin stopPropagation: si EasySell también escucha, hay que dejarle pasar */
    }

    function bindAll() {
      [].forEach.call(root.querySelectorAll('[data-px-scroll], [data-px-cta]'), bind);
      [].forEach.call(root.querySelectorAll('button, a, [role="button"]'), function (el) {
        var txt = (el.innerText || el.textContent || '').trim();
        if (txt && CTA_TEXT.test(txt)) bind(el);
      });
    }

    bindAll();
    setTimeout(bindAll, 1200);
    setTimeout(bindAll, 3500);
    document.addEventListener('shopify:section:load', bindAll);

    /* El botón de EasySell hereda el ancho de nuestra zona de compra
       y escondemos el nativo para que no haya dos botones. */
    function styleEs() {
      var es = liveEsButton();
      if (es && !es.dataset.pxStyled) {
        es.dataset.pxStyled = '1';
        es.style.width = '100%';
        es.style.boxSizing = 'border-box';
        var nb = nativeBtn();
        if (nb && visible(nb)) nb.classList.add('px-btn--offscreen');
      }
    }
    styleEs();
    setTimeout(styleEs, 1000);
    setTimeout(styleEs, 3000);

    /* La barra fija no debe tapar el popup */
    var sticky = root.querySelector('[data-px-sticky]');
    if (sticky) {
      var base = openSignature();
      setInterval(function () {
        var open = openSignature() > base;
        sticky.style.visibility = open ? 'hidden' : '';
        sticky.style.pointerEvents = open ? 'none' : '';
      }, 600);
    }

    /* ---- Diagnóstico ---- */
    window.pxDebug = function () {
      var nodes = document.querySelectorAll('[class*="es-popup" i],[id*="es-popup" i],[class*="easysell" i]');
      var lista = [];
      for (var i = 0; i < nodes.length && lista.length < 40; i++) {
        var n = nodes[i];
        lista.push((visible(n) ? '👁 ' : '   ') + n.tagName.toLowerCase() +
          (n.id ? '#' + n.id : '') +
          (typeof n.className === 'string' && n.className ? '.' + n.className.trim().split(/\s+/).join('.') : ''));
      }
      var info = {
        seccion: root.id,
        boton_easysell_encontrado: !!liveEsButton(),
        boton_nativo: !!nativeBtn(),
        formulario_incrustado: hasInline(),
        huella_actual: openSignature(),
        botones_enganchados: root.querySelectorAll('[data-px-bound]').length,
        globales: ['EasySell', 'easySell', 'easysell', 'ESF', 'Releasit'].filter(function (k) { return !!window[k]; }),
        nodos_es: lista
      };
      console.log(info);
      return info;
    };
    window.pxTry = function (n) {
      var s = STRATS[n];
      if (!s) { console.log('índice válido: 0 a ' + (STRATS.length - 1)); return; }
      console.log('probando:', s[0], '→', s[1]());
    };
  }

  /* =======================================================
     6. BARRA FIJA
     ======================================================= */
  function initSticky(root) {
    var sticky = root.querySelector('[data-px-sticky]');
    var target = root.querySelector('[data-px-buy]');
    if (!sticky || !target || !('IntersectionObserver' in window)) return;
    new IntersectionObserver(function (entries) {
      var en = entries[0];
      var show = !en.isIntersecting && en.boundingClientRect.top < 0;
      sticky.classList.toggle('is-visible', show);
      sticky.setAttribute('aria-hidden', show ? 'false' : 'true');
      var link = sticky.querySelector('a');
      if (link) link.tabIndex = show ? 0 : -1;
    }, { threshold: 0 }).observe(target);
  }

  /* =======================================================
     7. ESTADÍSTICAS ANIMADAS
     ======================================================= */
  function initStats(root) {
    var nums = root.querySelectorAll('[data-px-stat]');
    if (!nums.length || !('IntersectionObserver' in window)) return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (!en.isIntersecting) return;
        var el = en.target;
        io.unobserve(el);
        var raw = el.getAttribute('data-px-stat') || '';
        var target = parseInt(raw.replace(/\D/g, ''), 10);
        if (!target) return;
        var suffix = raw.replace(/[0-9]/g, '');
        var start = null;
        function stepF(ts) {
          if (!start) start = ts;
          var pr = Math.min((ts - start) / 900, 1);
          el.textContent = Math.round(target * (1 - Math.pow(1 - pr, 3))) + suffix;
          if (pr < 1) requestAnimationFrame(stepF);
        }
        requestAnimationFrame(stepF);
      });
    }, { threshold: .5 });

    [].forEach.call(nums, function (n) { io.observe(n); });
  }

  /* =======================================================
     8. CARRUSEL DE COMENTARIOS
     ======================================================= */
  function initComments(root) {
    var wrap = root.querySelector('[data-px-carousel]');
    if (!wrap) return;
    var track = wrap.querySelector('[data-px-c-track]');
    var items = [].slice.call(track.querySelectorAll('[data-px-c-item]'));
    var prev = wrap.querySelector('[data-px-c-prev]');
    var next = wrap.querySelector('[data-px-c-next]');
    var dotsWrap = root.querySelector('[data-px-c-dots]');
    if (!items.length) return;

    function step() {
      var cs = getComputedStyle(track);
      var gap = parseFloat(cs.columnGap || cs.gap || 12) || 12;
      return items[0].getBoundingClientRect().width + gap;
    }
    function currentIndex() { return Math.round(track.scrollLeft / step()); }
    function goTo(i) {
      i = Math.max(0, Math.min(items.length - 1, i));
      track.scrollTo({ left: i * step(), behavior: 'smooth' });
    }

    if (prev) prev.addEventListener('click', function () { goTo(currentIndex() - 1); });
    if (next) next.addEventListener('click', function () { goTo(currentIndex() + 1); });

    var dots = [];
    if (dotsWrap && items.length > 1) {
      items.forEach(function (item, i) {
        var d = document.createElement('button');
        d.type = 'button';
        d.className = 'px-fbc__dot' + (i === 0 ? ' is-active' : '');
        d.setAttribute('aria-label', 'Comentario ' + (i + 1));
        d.addEventListener('click', function () { goTo(i); });
        dotsWrap.appendChild(d);
        dots.push(d);
      });
    }

    function sync() {
      var i = currentIndex();
      dots.forEach(function (d, idx) { d.classList.toggle('is-active', idx === i); });
      if (prev) prev.disabled = track.scrollLeft <= 4;
      if (next) next.disabled = track.scrollLeft >= track.scrollWidth - track.clientWidth - 4;
    }
    var raf;
    track.addEventListener('scroll', function () {
      cancelAnimationFrame(raf);
      raf = requestAnimationFrame(sync);
    }, { passive: true });
    window.addEventListener('resize', sync);
    sync();

    [].forEach.call(wrap.querySelectorAll('[data-px-like]'), function (btn) {
      btn.addEventListener('click', function () {
        var card = btn.closest('[data-px-c-item]');
        var count = card.querySelector('[data-px-like-count]');
        var liked = btn.classList.toggle('is-liked');
        if (count) count.textContent = Number(count.textContent) + (liked ? 1 : -1);
      });
    });
  }

  /* =======================================================
     9. FAQ
     ======================================================= */
  function initFaq(root) {
    var items = [].slice.call(root.querySelectorAll('[data-px-faq] details'));
    items.forEach(function (d) {
      d.addEventListener('toggle', function () {
        if (!d.open) return;
        items.forEach(function (o) { if (o !== d) o.open = false; });
      });
    });
  }

  /* =======================================================
     INIT
     ======================================================= */
  function init(root) {
    if (root.dataset.pxReady) return;
    root.dataset.pxReady = '1';
    initCountdown(root);
    initAnnounce(root);
    initGallery(root);
    initPacks(root);
    initCTAs(root);
    initSticky(root);
    initStats(root);
    initComments(root);
    initFaq(root);
  }

  function boot() { [].forEach.call(document.querySelectorAll('[data-px-root]'), init); }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();